import React from 'react'
import { twMerge } from 'tailwind-merge'

const Section = ({children, id, className, center, padded}) => {
  return (
    <section className={twMerge('relative flex flex-col bg-dark w-full h-full', center && "items-center", padded && "py-32", className)}>
      {children}
    </section>
  )
}

export default Section